import { makeAutoObservable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'
import PPQuestion from './Question'

export default class PPSlide {
    id = uuidv4()

    title = ''

    template = ''

    question = new Map()

    constructor(props = {}) {
        this.title = props.title ?? ''
        this.template = props.template ?? ''

        if (props.question instanceof Map) {
            this.question = props.question
        }

        makeAutoObservable(this)
    }

    getQuestionAtPosition(position) {
        return this.question.get(position)
    }

    addQuestion(position, question) {
        this.question.set(position, new PPQuestion(question, this.store))
    }

    removeQuestion(position) {
        this.question.delete(position)
    }

    updateTitle(event) {
        this.title = event.value
    }

    updateTemplate(template) {
        this.template = template
    }

    getQuestionCharts() {
        const questions = [...this.question.values()]

        return questions.map((q) => q.chart)
    }

    toJSON = () => ({
        id: this.id,
        title: this.title,
        template: this.template,
        question: Array.from(this.question.values()),
    })
}
